export enum DateRange {
	Past = 0,
	Future = 1,
}
